import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { Select, Row, Col } from 'antd';
import axios from 'axios';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';

const { Option } = Select;

const FontFamilySelector: React.FC<DynamicComponentProps<string>> = ({ value, onChange }) => {
  const [fontFamilies, setFontFamilies] = useState<string[]>([]);

  const key = 'AIzaSyCvz-2DGOCzylPPZARU0gqh2oBQLr24tGU';

  // Fetch font families from Google Fonts API
  useEffect(() => {
    const fetchFonts = async () => {
      try {
        const response = await axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${key}`);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        const fonts = (response.data.items as { family: string }[]).map(font => font.family);
        setFontFamilies(fonts);
      } catch (error) {
        console.error('Error fetching font families:', error);
      }
    };

    fetchFonts();
  }, []);

  // Handle font family change
  const handleChange = useCallback(
    (value: string) => {
      onChange?.(value);
    },
    [onChange],
  );

  return (
    <div className={`${styles.font_family_wrapper}`}>
      <Row>
        <Col span={8}>
          <Select
            value={value}
            onChange={handleChange}
            loading={fontFamilies.length === 0}
            popupMatchSelectWidth={false}
          >
            {fontFamilies.map((font, index) => (
              <Option key={index} value={font}>
                {font}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </div>
  );
};

export default FontFamilySelector;
